import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'convertToNumber'
})
export class ConvertToNumberPipe implements PipeTransform {
	transform(_value: any, _args?: unknown): any {
		return null;
	}
}
